import apiWorker from '../apiWorker'

const events = {
    create : (data) => apiWorker('post', `/v1/api/events/${data.contact}/${data.company}/${data.access_code}`, data),
}

export default events;